module.exports = __webpack_public_path__ + "img/xk_4.5cf8a282.png";